export const cilCaretTop = ["24 24","<path d='M23.25 18.767h-22.484v-1.709l11.237-12.558 11.248 12.647zM2.592 17.267h18.757l-9.35-10.513z'></path>"]